<template>
  <div>
    <Floating
      :visible.sync="showTerms"
      :width="'470px'"
      :height="'584px'"
      v-if="!isH5"
      custom-class="terms-popup-floating"
      :title="i18n.t('使用规则')"
      @close="closeDrawer"
      :appendToBody="false"
    >
      <div slot="icon" class="floating-footer">
        <i class="el-floating__close el-icon el-icon-back"></i>
      </div>
      <TermsContent />
    </Floating>
    <DrawerPopup
      v-if="isH5"
      size="90%"
      :show="showTerms"
      :appendToBody="false"
      :title="i18n.t('使用规则')"
      bottomName="Confirm"
      @close="closeDrawer"
      @bottom-click="confirmClick"
    >
      <TermsContent />
    </DrawerPopup>
  </div>
</template>

<script>
import DrawerPopup from '@/components/DrawerPopup';
import TermsContent from './termsContent.vue';
import { Floating } from '@didi/r-fusion-pc';
import { mapState } from 'vuex';
import i18n from '@/i18n/locale';

export default {
  name: 'TermsPopup',
  components: {
    DrawerPopup,
    TermsContent,
    Floating,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTerms: true,
      i18n: i18n,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  watch: {
    value(val) {
      this.showTerms = val;
    },
    showTerms(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    closeDrawer() {
      this.closeDrawer2();
      this.showTerms = false;
    },
    confirmClick() {
      this.confirmClick2();
      this.showTerms = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: 'Aspira Light';
  font-size: 12px;
  margin-top: 8px;
  cursor: pointer;
}
.terms-popup-floating {
  height: 656px;
}
</style>